import React, { useRef, useMemo } from 'react';
import { debounce } from 'lodash';

const useChartOptions = (options: any) => {
  const chartRef = useRef<any>(null);

  const handleResize = useMemo(
    () =>
      debounce(() => {
        if (chartRef.current) {
          chartRef.current.getEchartsInstance().resize();
        }
      }, 100),
    []
  );

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return { options, chartRef };
};

export default useChartOptions;